module.exports = function (app) {
    'use strict';
    app.directive('typeahead', function ($timeout) {
        return {
            template: require('directives/common/typeahead.html'),
            scope: {
              items: '=',
              prompt: '@',
              title: '@',
              subtitle: '@',
              model: '=',
              modelObject: '=',
              onSelect: '&'
            },
            link: function(scope, elem, attrs) {
                scope.handleSelection = function(selectedItemDisplay, selectedItem) {
                    scope.model = selectedItemDisplay;
                    scope.modelObject = selectedItem;
                    scope.current = 0;
                    scope.selected = true;
                    $timeout(function() {
                      scope.onSelect(selectedItem);
                    }, 200);
                };

              scope.current = 0;
              scope.selected = true; // hides the list initially
              scope.isCurrent = function(index) {
                return scope.current == index;
              };
              scope.setCurrent = function(index) {
                scope.current = index;
              };
            }
        };
    });
};
